import { Auth } from "components/Parts/Organisms/Auth";
import { HomePage } from "components/Parts/Organisms/HomePage";
import React from "react";

export const Home = React.memo(() => {
  return (
    <Auth>
      <HomePage />
    </Auth>
  );
});
